import { Badge } from "@/components/ui/badge";

const STYLES = {
  pending: "bg-[hsl(30,18%,92%)] text-[hsl(20,14%,18%)] border-[hsl(28,14%,82%)]",
  countered: "bg-[hsl(43,74%,92%)] text-[hsl(43,60%,22%)] border-[hsl(43,74%,70%)]",
  accepted: "bg-[hsl(174,38%,92%)] text-[hsl(174,45%,18%)] border-[hsl(174,38%,70%)]",
  declined: "bg-[hsl(6,62%,92%)] text-[hsl(6,55%,22%)] border-[hsl(6,62%,72%)]",
  paid: "bg-[hsl(210,30%,92%)] text-[hsl(210,35%,22%)] border-[hsl(210,30%,72%)]",
  active: "bg-[hsl(174,38%,92%)] text-[hsl(174,45%,18%)] border-[hsl(174,38%,70%)]",
  expired: "bg-[hsl(20,8%,92%)] text-[hsl(20,10%,28%)] border-[hsl(20,8%,78%)]",
};

const LABELS = {
  pending: "Pending",
  countered: "Countered",
  accepted: "Accepted · Awaiting payment",
  declined: "Declined",
  paid: "Paid",
  active: "Active",
  expired: "Expired",
};

export const StatusBadge = ({ status, className = "" }) => (
  <Badge
    data-testid="booking-status-badge"
    variant="outline"
    className={`rounded-full px-2.5 py-1 text-[11px] font-medium tracking-wide ${STYLES[status] || STYLES.pending} ${className}`}
  >
    {LABELS[status] || status}
  </Badge>
);
